export enum STATUS_POD_CODE {
  INACTIVE = 'INAC',
  ACTIVE = 'ACTI',
  REQUIRED = 'RQST',
}
